import { IGetOrdersByRiderModel } from "../models/GetOrdersByRider.Model";
import { IOrderOtpView } from "../models/OrderOtpView.Model";
import { isTokenExpired } from "../helpers/TokenHelper";
import createHttpInstance from "./http-common";

class SellServices {
  private serviceName = "/sell";

  async GetOrdersByRider(data: IGetOrdersByRiderModel) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/GetOrdersByRider`, data)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async GetDashboardStats(isToday: boolean) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .get(`${this.serviceName}/GetDashboardStats?isToday=${isToday}`)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async AssignProcess(orderId: any, AssigneeId: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/AssignProcess/${orderId}/${AssigneeId}`)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async GetOrderSummary(Id: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .get(`${this.serviceName}/GetOrderSummary/${Id}`)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async GetOrderSummaryWithTemplate(Id: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .get(`${this.serviceName}/GetOrderSummaryWithTemplate/${Id}`)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async PagedOrdersList(data: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/GetElasticOrderSearchResult`, data)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async OrderCompleted(orderId: any, personId: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/OrderCompleted/${orderId}/${personId}`)
      .catch((err) => {
        throw err?.message;
      });
  }

  async OrderRetrieved(orderId: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/RetrieveOrder/${orderId}`)
      .catch((err) => {
        throw err?.message;
      });
  }

  async GetOrderOTP(orderId: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .get(`${this.serviceName}/GetOrderOTP/${orderId}`)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async ValidateOrderOTP(data: IOrderOtpView) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/ValidateOrderOTP`, data)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async SkipOTP(data: IOrderOtpView) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/SkipOTP`, data)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async DownloadElasticOrdersList(data: IGetOrdersByRiderModel) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon
      .post(`${this.serviceName}/DownloadElasticOrdersList`, data)
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async DownloadOrderInvoiceWithDocuments(orderId: any, questionaireVersion: any, LanguageCode: any, CountryCode: any) {
    isTokenExpired();
    const httpCommon = await createHttpInstance();
    return httpCommon.post(`${this.serviceName}/DownloadOrderInvoiceWithDocuments/${orderId}/${questionaireVersion}`, {
      headers: {
        LanguageCode: LanguageCode,
        CountryCode: CountryCode,
      }
    })
      .catch((err: Error) => {
        throw err?.message;
      });
  }

  async GetOrderInvoice(orderid: any, LanguageCode: any, CountryCode: any) {
    isTokenExpired();
    let param = {
      orderId:orderid
    }
    const httpCommon = await createHttpInstance();
    return httpCommon.post(`${this.serviceName}/GetOrderInvoice/`,param, {
      headers: {
        LanguageCode: LanguageCode,
        CountryCode: CountryCode,
      },
    })
      .catch((err: Error) => {
        throw err?.message;
      });
  }
}
export default new SellServices();
